module.exports = __webpack_public_path__ + "static/media/Logo_Addison.974ccf4d.svg";